export const EnvContribution = Symbol.for('EnvContribution');
export const VGlobal = Symbol.for('VGlobal');
